<template>
  <v-layout wrap justify-center align-center>
    <v-flex xs12>
      <v-card max-width="600">
        <v-card-text class="entire-field">
            {{field}}
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'PEntireField',
    props: ['field']
  }
</script>

<style>
  .entire-field {
    font-size: 12px;
    font-size-adjust: initial;
    color: black;
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PEntireField.vue